export const types = {
  CLOSE: 'contacts/contactDetails/accountsDrawer/CLOSE',
  OPEN: 'contacts/contactDetails/accountsDrawer/OPEN',
};

export const accountsDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  open: () => ({
    type: types.OPEN,
  }),
};
